<template>
  <el-dialog
    class="custon-dialog-title"
    :title="isConcluida ? 'Detalhes da Visita' : 'Cadastrar Visita'"
    @open="iniciar"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    width="50%"
    v-loading="loading"
  >
    <el-form
      ref="form"
      :model="visita"
      :rules="validacao"
      size="small"
      label-position="top"
      hide-required-asterisk
      :show-message="false"
    >
      <el-form-item label="Data/Hora" prop="dataHora" v-if="!isConcluida">
        <el-date-picker
          v-model="visita.dataHora"
          type="datetime"
          format="dd/MM/yyyy HH:mm"
          value-format="dd/MM/yyyy HH:mm"
          v-mask="'##/##/#### ##:##'"
          style="width: 100%"
          :disabled="habilitarCampos"
        />
      </el-form-item>

      <el-row :gutter="10">
        <el-col :span="20" :xs="18">
          <el-form-item
            label="Cliente"
            style="width: 100%"
            prop="cliente"
            v-if="!isConcluida"
          >
            <el-select
              v-model="visita.cliente"
              :remote-method="recuperarClientesSelect"
              :loading="loadingClientes"
              value-key="id"
              placeholder
              loading-text="Carregando clientes"
              no-data-text="Nenhum cliente encontrado"
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              :disabled="habilitarCampos"
            >
              <el-option
                v-for="item in clientesDisponiveis"
                :key="item.id"
                :label="formatarSelectCliente(item)"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="4" :xs="6">
          <el-form-item label=" " v-if="!isConcluida">
            <el-button
              type="primary"
              size="small"
              style="width: 100%"
              @click="exibirDialogGravarCliente"
              round
              class="btn-box-shadow"
              >Novo</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item
        label="Corretor"
        style="width: 100%"
        prop="usuario"
        v-if="!isConcluida"
      >
        <el-select
          v-model="visita.usuario"
          :remote-method="recuperarUsuariosSelect"
          :loading="loadingUsuarios"
          value-key="id"
          placeholder
          loading-text="Carregando atendentes"
          no-data-text="Nenhum atendente encontrado"
          filterable
          remote
          reserve-keyword
          style="width: 100%"
          :disabled="habilitarCampos"
        >
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="Descrição" v-if="!isConcluida">
        <el-input
          rows="6"
          v-model="visita.descricao"
          type="textarea"
          :disabled="habilitarCampos"
        />
      </el-form-item>

      <el-form-item
        v-if="exibirSituacaoChave && !isConcluida"
        label="Situação da Chave"
        class="dont-word-wrap"
      >
        <p
          v-for="(mensagem, indice) in this.getMensagensChave()"
          v-text="mensagem"
          :key="indice"
          style="margin: 0; padding: 0"
        ></p>
      </el-form-item>

      <!-- DATA HORA VISITA CONCLUIDA -->
      <el-row :gutter="10" v-if="isConcluida">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Data/Hora de Abertura</label>
            <span>{{ visita.dataHora }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- CLIENTE VISITA CONCLUIDA -->
      <el-row :gutter="10" v-if="isConcluida">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Cliente</label>
            <span>{{ visita.cliente.nome }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- CORRETOR VISITA CONCLUIDA -->
      <el-row :gutter="10" v-if="isConcluida">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Corretor</label>
            <span>{{ visita.usuario.nome }}</span>
          </div>
        </el-col>
      </el-row>

      <el-form-item label="Imóvel" v-if="!isConcluida">
        <el-input :value="enderecoImovel" readonly />
      </el-form-item>

      <!-- IMOVEL VISITA CONCLUIDA -->
      <el-row :gutter="10" v-if="isConcluida">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Imóvel</label>
            <span>{{ enderecoImovel }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- DESCRICAO VISITA CONCLUIDA -->
      <el-row :gutter="10" v-if="isConcluida">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Descrição</label>
            <span>{{ visita.descricao }}</span>
          </div>
        </el-col>
      </el-row>

      <!-- SITUACAO CHAVE VISITA CONCLUIDA -->
      <el-row :gutter="10" v-if="isConcluida">
        <el-col :span="24">
          <div class="details">
            <label class="font-label">Situação da Chave</label>
            <p
              v-for="(mensagem, indice) in this.getMensagensChave()"
              v-text="mensagem"
              :key="indice"
              style="margin: 0; padding: 0"
            ></p>
          </div>
        </el-col>
      </el-row>

      <div class="box-rating">
        <div v-show="exibirAvaliar" class="rating-container">
          <h3>Avaliação do imóvel</h3>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-rate
                v-model="visita.imovel.avaliacao"
                :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
              />
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" style="padding: 6px; 0px;">
              <el-input
                v-model="visita.imovel.opiniaoCliente"
                size="small"
                placeholder="Digite aqui a opinião do cliente"
                v-show="visita.imovel.avaliacao > 0"
              />
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="padding: 10px; 0px;">
              <el-button
                type="success"
                icon="el-icon-check"
                round
                @click="gravarAvaliacao()"
                style="padding: 5px"
                v-show="visita.imovel.avaliacao > 0"
                >Submeter Avaliação</el-button
              >
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-row>
        <el-col :span="12">
          <el-row type="flex" justify="start">
            <el-button
              v-if="exibirBotaoGerarDeclaracaoRetiradaChave"
              @click="gerarDeclaracaoRetiradaChaveHandler"
              type="primary"
              size="small"
              round
              class="btn-box-shadow"
            >
              Declaração de Retirada de Chave
            </el-button>
          </el-row>
        </el-col>
        <el-col :span="exibirBotaoGerarDeclaracaoRetiradaChave ? 12 : 24">
          <el-row type="flex" justify="end">
            <el-button
              v-if="exibirBotaoEntregarChave"
              @click="confirmarEntregaChave"
              type="warning"
              size="small"
              :disabled="entregarChaveIsPossible"
              round
              class="btn-box-shadow"
            >
              Entregar Chave
            </el-button>

            <el-button
              v-if="exibirBotaoReceberChave"
              @click="confirmarRecebimentoChave"
              type="warning"
              size="small"
              round
              class="btn-box-shadow"
            >
              Receber Chave
            </el-button>

            <el-button
              v-if="!isConcluida"
              :disabled="habilitarBotaoGravar"
              @click="gravarHandler()"
              type="success"
              size="small"
              round
              class="btn-box-shadow"
            >
              Gravar
            </el-button>

            <el-button
              v-if="exibirBotaoAvaliar"
              @click="alterarExibirAvaliacao()"
              type="warning"
              size="small"
              round
              class="btn-box-shadow"
              >Avaliar
            </el-button>

            <el-button
              @click="fechar()"
              type="danger"
              size="small"
              round
              class="btn-box-shadow"
            >
              Fechar
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </span>

    <app-gravar-cliente-dialog
      tipo="VISITA"
      @close="fecharDialogGravarCliente"
      :visibility="visibilidadeGravarClienteDialog"
    />
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";

import AppGravarClienteDialog from "../../../shared/dialogs/GravarClienteDialog.vue";

import URLS from "../../../util/urls.js";
import Util from "../../../util/funcoes.js";
import { validadorDataHora } from "../../../util/validadores";

export default {
  components: {
    AppGravarClienteDialog,
  },
  props: {
    visibility: Boolean,
    visitaSelecionada: Object,
  },
  data() {
    return {
      validacao: {
        dataHora: [{ validator: validadorDataHora, trigger: "blur" }],
        cliente: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1, trigger: "change" },
            },
          },
        ],
        usuario: [
          {
            type: "object",
            required: true,
            fields: {
              id: { type: "number", required: true, min: 1, trigger: "change" },
            },
          },
        ],
      },
      loadingClientes: false,
      loadingUsuarios: false,
      visibilidadeAvaliacao: false,

      visita: {
        dataHora: Util.agora(),
        descricao: "",
        cliente: { id: 0 },
        usuario: this.usuarioLogado,
        id: 0,
        imovel: {
          id: 0,
          endereco: "",
          avaliacao: 0,
          idNaImobiliaria: 0,
          numeroEndereco: 0,
          opiniaoCliente: "",
        },
      },

      clientesDisponiveis: [],
      usuariosDisponiveis: [],

      visibilidadeGravarClienteDialog: false,
    };
  },
  computed: {
    ...mapState("loginStore", {
      usuarioLogado(state) {
        return state.usuarioLogado;
      },
    }),
    ...mapState("vendasImoveisStore", {
      imovel(state) {
        return state.imovelSelecionado;
      },
      placasDisponiveis(state) {
        return state.placasDisponiveis;
      },
      visitaAtiva(state) {
        return state.visitaAtiva;
      },
    }),

    clienteTemAChave() {
      return this.visita.chavePosseCliente;
    },
    clienteNaoTemAChave() {
      return !this.clienteTemAChave;
    },
    visitaJaExiste() {
      return this.visita.id !== undefined;
    },

    exibirSituacaoChave() {
      return this.visitaJaExiste;
    },
    exibirBotaoEntregarChave() {
      if (
        this.visitaJaExiste &&
        this.clienteNaoTemAChave &&
        this.visita.mensagemChave !== null
      ) {
        return false;
      }
      return this.visitaJaExiste && this.clienteNaoTemAChave;
    },
    exibirBotaoReceberChave() {
      return this.visitaJaExiste && this.clienteTemAChave;
    },
    exibirBotaoGerarDeclaracaoRetiradaChave() {
      return this.visitaJaExiste && this.clienteTemAChave;
    },

    enderecoImovel() {
      return Util.formatarEnderecoImovel(this.imovel);
    },

    loading() {
      return this.$store.state.loading;
    },

    entregarChaveIsPossible() {
      return this.visitaAtiva.id != 0 && this.clienteNaoTemAChave;
    },

    habilitarBotaoGravar() {
      return (
        this.visitaJaExiste &&
        this.clienteNaoTemAChave &&
        this.visita.mensagemChave !== null
      );
    },

    habilitarCampos() {
      return this.clienteTemAChave && this.visita.mensagemChave != null;
    },

    isConcluida() {
      return (
        this.visita.chavePosseCliente == false &&
        (this.visita.mensagemChave == null
          ? false
          : this.visita.id === this.visitaAtiva.id
          ? false
          : true)
      );
    },

    exibirBotaoAvaliar() {
      return (
        this.visita.chavePosseCliente == false &&
        (this.visita.mensagemChave == null
          ? false
          : this.visita.id === this.visitaAtiva.id
          ? false
          : true) &&
        this.visita.imovel.avaliacao === 0
      );
    },
    exibirAvaliar() {
      return this.visita.chavePosseCliente == false &&
        this.visita.mensagemChave == null
        ? false
        : this.visita.id === this.visitaAtiva.id
        ? false
        : (true && this.visita.imovel.avaliacao > 0) ||
          this.visibilidadeAvaliacao;
    },
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("loginStore", ["relogar"]),
    ...mapActions("vendasImoveisStore", [
      "gravarVisitaImovel",
      "gravarAvaliacaoVisita",
      "entregarChave",
      "receberChave",
      "gerarDeclaracaoRetiradaChave",
    ]),
    iniciar() {
      this.reset();

      if (this.visitaSelecionada) {
        this.visita = this.visitaSelecionada;
        this.visita.imovel = this.visitaSelecionada.imovel;
        this.clientesDisponiveis = [this.visitaSelecionada.cliente];
        this.usuariosDisponiveis = [this.visitaSelecionada.usuario];
      }
    },
    gravarHandler() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.gravar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      let payload = this.visita;
      payload.imoveis = [{ id: this.imovel.id }];

      this.showLoading();
      this.gravarVisitaImovel(payload)
        .then((resultado) => {
          this.hideLoading();

          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.warning(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.hideLoading();
        });
    },
    gravarAvaliacao() {
      const payload = this.visita;

      this.showLoading();
      this.gravarAvaliacaoVisita(payload)
        .then((resultado) => {
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "FALHA":
            case "ERRO":
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch(() => {
          this.$message.error("Não foi possível comunicar-se com o servidor");
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    confirmarEntregaChave() {
      this.$confirm(
        `Confirmar liberação de chave pelo usuário ${this.usuarioLogado.nome}?`,
        "Atenção",
        {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning",
        }
      )
        .then(() => {
          this.entregarChaveHandler();
        })
        .catch(() => {});
    },
    entregarChaveHandler() {
      this.showLoading();
      this.visita.imovel = this.imovel;
      this.entregarChave(this.visita)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    confirmarRecebimentoChave() {
      this.$confirm(
        `Confirmar o recebimento de chave pelo usuário ${this.usuarioLogado.nome}?`,
        "Atenção",
        {
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          type: "warning",
        }
      )
        .then(() => {
          this.receberChaveHandler();
        })
        .catch(() => {});
    },
    receberChaveHandler() {
      this.showLoading();
      this.visita.imovel = this.imovel;
      this.receberChave(this.visita)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar();
              break;
            case "ERRO":
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    gerarDeclaracaoRetiradaChaveHandler() {
      const relatorio = {
        nome: "DECLARACAO_RETIRADA_CHAVE",
        visita: { id: this.visita.id },
      };

      this.showLoading();
      this.gerarDeclaracaoRetiradaChave(relatorio)
        .then((resultado) => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO": {
              const urlRelatorio = resultado.mensagem;

              window.open(urlRelatorio, "_blank");
              break;
            }
            case "FALHA":
              this.$message.warning("Não foi possível gerar o relatório");
          }
        })
        .catch(() => {
          this.hideLoading();
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },

    recuperarClientesSelect(queryString) {
      const payload = {};

      const numberRegexPattern = /^\d+$/;
      const isPesquisaPorId = numberRegexPattern.test(queryString);

      isPesquisaPorId
        ? (payload.idNaImobiliaria = queryString)
        : (payload.nome = queryString);

      this.loadingClientes = true;

      this.listarClientes(payload)
        .then((resultado) => {
          this.clientesDisponiveis = resultado.lista;
        })
        .catch(() => {
          this.clientesDisponiveis = [];
        })
        .finally(() => {
          this.loadingClientes = false;
        });
    },
    listarClientes(payload) {
      return axios
        .post(URLS.CLIENTES_LISTAR, payload)
        .then((response) => {
          if (response.data.status === "SESSAO_EXPIRADA") {
            return this.relogar().then((authResponse) => {
              if (authResponse.status === "SUCESSO") {
                return this.listarClientes(payload);
              }
            });
          }

          return response.data;
        })
        .catch((error) => {
          throw error;
        });
    },
    recuperarUsuariosSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingUsuarios = true;

      axios
        .post(URLS.USUARIOS_LISTAR, payload)
        .then((response) => {
          this.usuariosDisponiveis = response.data.lista;
          this.loadingUsuarios = false;
        })
        .catch(() => {
          this.usuariosDisponiveis = [];
          this.loadingUsuarios = false;
        });
    },

    exibirDialogGravarCliente() {
      this.visibilidadeGravarClienteDialog = true;
    },
    fecharDialogGravarCliente(cliente) {
      if (cliente) {
        this.visita.cliente = cliente;
        this.clientesDisponiveis = [cliente];
      }
      this.visibilidadeGravarClienteDialog = false;
    },

    formatarSelectCliente(cliente) {
      return Util.formatarSelectCliente(cliente);
    },
    getMensagensChave() {
      if (this.visita.mensagemChave) {
        const mensagens = this.visita.mensagemChave.split("\n");
        return mensagens.slice(0, -1);
      }
      return [];
    },
    alterarExibirAvaliacao() {
      this.visibilidadeAvaliacao = !this.visibilidadeAvaliacao;
    },

    reset() {
      this.visita = {
        dataHora: Util.agora(),
        descricao: "",
        cliente: { id: 0 },
        usuario: this.usuarioLogado,
        imovel: {
          id: 0,
          endereco: "",
          avaliacao: 0,
          idNaImobiliaria: 0,
          numeroEndereco: 0,
          opiniaoCliente: "",
        },
      };
      this.clientesDisponiveis = [];
      this.usuariosDisponiveis = [this.usuarioLogado];
      this.visibilidadeAvaliacao = false;
    },
    fechar() {
      this.$refs["form"].resetFields();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.dont-word-wrap {
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: normal;
}

.box-rating {
  display: flex;
  justify-content: center;
  align-items: center;
}

.rating-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgb(173, 173, 173);
  text-align: center;
  max-width: 60%;
  width: 100%;
  margin-top: 20px;
}
.details {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  padding: 10px;
  background-color: #f9f9f9;
  border-left: 4px solid #28a745;
  border-radius: 5px;
}
.font-label {
  font-weight: bold;
  font: 15px;
  margin-bottom: 5px;
  color: rgb(66, 66, 66);
}
.custon-dialog-title {
  text-align: center;
}
</style>